module.exports = __webpack_public_path__ + "static/img/49.bedebef3.gif";